import React, { Component } from 'react';
//import Filter from './filter.js';

class Filters extends Component {
	
    arrCurrentSelected = [];
    result = 0;

    /*
     *  Filters
     *     
     *
    */
   

    setFilter(event,filter){

        
        //get classname from attribute
        var classname = event.target.getAttribute("data-label");
        let messageBox = document.getElementById('searchMessageRow'); 

        if(classname==='clear'){
            this.clearFilters();
            this.clearTiles();
        }
        else if(classname==='all'){
            let allcheck = document.querySelector('[data-label="'+classname+'"]');
            if(allcheck.classList.contains('selected')){
                this.clearFilters();
                this.clearTiles();
                allcheck.innerHTML="Select All";
                //hide message
                messageBox.classList.remove('hidden');
            }
            else{
                this.resetFilters();
                //this.resetTiles();
                allcheck.innerHTML="Unselect All";
                messageBox.classList.add('hidden');
            }
            
        }
        else{
            this.clearAllTab();
            //hide message
            
            messageBox.classList.add('hidden');
            //use classname to get selector object
            let grab = document.querySelector('[data-label="'+classname+'"]');
            //check of has class selected, if not add
            if(grab.classList.contains('selected')){
                grab.classList.remove('selected');
            }
            else{
                grab.classList.add('selected');
            }


            let check = false;
            for (var n=0; n < this.arrCurrentSelected.length; n++) {
                if (this.arrCurrentSelected[n] === classname) {
                    check=true;
                }
            }
            if( (!check && classname!=='all') ){
                this.arrCurrentSelected.push(classname);
            }
            else{
                var index = this.arrCurrentSelected.indexOf(classname);
                this.arrCurrentSelected.splice(index,1);
            }

            if(this.arrCurrentSelected.length===0){
                //this.setAllTab();

                if(classname==='all'){
                    //this.resetTiles();
                }
                else{
                    this.clearTiles();
                }
                messageBox.classList.remove('hidden');    
            }
            else{

                var checkAll = this.checkIfAllSelected();
                if(checkAll){
                    let allcheck = document.querySelector('[data-label="all"]');
                    allcheck.innerHTML="Unselect All";
                    allcheck.classList.add('selected');
                }
                //console.log('================> this.arrCurrentSelected: ', this.arrCurrentSelected);
                this.updateTileStatus();
            }
            
        }

    }

    checkArraysMatch(_arr1, _arr2) {

        if (
            !Array.isArray(_arr1)
            || !Array.isArray(_arr2)
            || _arr1.length !== _arr2.length
            ) {
              return false;
            }
          
          const arr1 = _arr1.concat().sort();
          const arr2 = _arr2.concat().sort();
          
          for (let i = 0; i < arr1.length; i++) {
              if (arr1[i] !== arr2[i]) {
                  return false;
               }
          }
          
          return true;
    
    };

    checkIfAllSelected(){

        var arrTabs = [];                
        document.querySelectorAll('[data-tag="filter-tag"]').forEach((tab) => {

                
                var classname = tab.getAttribute("data-label");

                // let check = false;
                // for (var n=0; n < this.arrCurrentSelected.length; n++) {
                //     if (this.arrCurrentSelected[n] === classname) {
                //         check=true;
                //     }
                // }
                if( (classname!=='all') ){
                    arrTabs.push(classname);
                }

                //console.log('*****>> Filters tab classname: ', classname);
                

        });


        var check = this.checkArraysMatch(arrTabs, this.arrCurrentSelected);
        if(check){
            //console.log('they match!!!');
        }    
        else{
            //console.log('buuuuummer!!!');
        }
        //console.log('================> arrTabs: ', arrTabs);
        //console.log('================> this.arrCurrentSelected: ', this.arrCurrentSelected);

        return check;
    }

    setAllTab(){
        //use classname to get selector object
        let allTab = document.querySelector('[data-label="all"]');
        
        if(!allTab){
            allTab = document.querySelector('[data-label="clear"]');
        }
        
        //check of has class selected, if not add
        if(!allTab.classList.contains('selected')){
            allTab.classList.add('selected');
        }
        else{
            alert('selected!');
        }
        // else {
        //     alert('selected!');
        //     allTab.classList.remove('selected');
        // }
    }

    clearAllTab(){

        //use classname to get selector object
        let allTab = document.querySelector('[data-label="all"]');
        
        if(!allTab){
            allTab = document.querySelector('[data-label="clear"]');
        }
        //check of has class selected, if not add
        if(allTab.classList.contains('selected')){
            allTab.classList.remove('selected');
        }

        allTab.innerHTML = "Select All";
    }

    clearFilters(){
           //grab all filter tabs data-tag="filter-tag"
        //remove selected
        document.querySelectorAll('[data-tag="filter-tag"]').forEach((tab) => {
                //console.log('*****>> Filters tab: ', tab);
                if(tab.classList.contains('selected')){
                    tab.classList.remove('selected');
                }
        });

    }
    resetFilters(){


        //grab all filter tabs data-tag="filter-tag"
        //grab each tab and trigger click
        document.querySelectorAll('[data-tag="filter-tag"]').forEach((tab) => {
                
               var classname = tab.getAttribute("data-label");

                let check = false;
                for (var n=0; n < this.arrCurrentSelected.length; n++) {
                    if (this.arrCurrentSelected[n] === classname) {
                        check=true;
                    }
                }
                if( (!check && classname!=='all') ){
                    this.arrCurrentSelected.push(classname);
                    tab.classList.add('selected'); 
                }

        });

        this.updateTileStatus();

        this.setAllTab();
    }


    updateTileStatus(){

        let counter = 0;    
        //remove selected
        document.querySelectorAll('.product').forEach((tile) => {
                let tilestatus = false;
                if(this.arrCurrentSelected.length>0){
                    for (var i=0; i < this.arrCurrentSelected.length; i++) {
                        if(tile.firstChild.classList.contains(this.arrCurrentSelected[i])){
                            tilestatus=true;
                        }
                    }
                    if(!tilestatus){
                        tile.classList.add('hidden');
                    }
                    else{
                        tile.classList.remove('hidden');
                        counter++;
                    }
                }
                else{
                    tile.classList.remove('hidden');
                }
                
        });
        
         this.result = counter;
         let resultwrap = document.getElementById('found'); 
         resultwrap.innerHTML = this.result;
    }

    clearTiles(){

        this.arrCurrentSelected = [];    
        //remove selected
        let counter = 0;
            document.querySelectorAll('.product').forEach((tile) => {    
                tile.classList.add('hidden');
                counter++;
            });

        let resultwrap = document.getElementById('found'); 
        resultwrap.innerHTML = counter;

    }

    resetTiles(){

        this.arrCurrentSelected = [];    
        //remove selected
        let counter = 0;
        document.querySelectorAll('.product').forEach((tile) => {    
            if(tile.classList.contains('hidden')){
                tile.classList.remove('hidden');
            }
            counter++;
        });

        let resultwrap = document.getElementById('found'); 
        resultwrap.innerHTML = counter;

    }
    
    setFirstLoad(){

    }

  	render() {
        
        
        let config =  	this.props.config;
        let path =  	this.props.path;

        //let currentCategory = config.categories.find(h => h.path === path.substring(1));
        let currentCategory = config.categories.find(h => h.path === path.split('/').slice(-1)[0]);

        let products = currentCategory.products;

        // let arrFilters = [{
        //     "label":"All",
        //     "class":"all"
        // }];
        
        let arrFilters = [];
        arrFilters = currentCategory.filters;
        
        if(currentCategory.filters.length>0){

            let test = arrFilters.find(h => h.class === 'all');
            if(!test){
                arrFilters.push({
                    "label":"Select All",
                    "class":"all"
                });
            }
        }

        // arrFilters.push({
        //     "label":"Clear",
        //     "class":"clear"
        // });
        
        let arrTabs = [];
        
        for ( let b = 0; b < arrFilters.length; b++ ) {
  			
            var filterclass = arrFilters[b].class;
            var filterlabel = arrFilters[b].label;
            if(b===0){
                arrTabs.push(<div key={b} onClick={(event) => this.setFilter(event, b)} data-tag="filter-tag" className="" data-label={filterclass}>{filterlabel}</div>);
            }
            else{
                arrTabs.push(<div key={b} onClick={(event) => this.setFilter(event, b)} data-tag="filter-tag" data-label={filterclass}>{filterlabel}</div>);
            }    
        }

        let classSet = 'filters';
        if(products.length===0){
            classSet = 'filters hidden'
        }

        else if(arrFilters.length===1 && arrFilters[0].class==='clear'){    
            classSet = 'filters hidden'
        }
        else if(arrFilters.length===0){    
            classSet = 'filters hidden'
        }


  		return (

            <div className={classSet}>  
                <div className="filterstext"> Filter by:</div>    
                <div className="filterstabs">  
                  {arrTabs}
                </div>
                <div className="founditems"><span id="found">{this.result}</span> Results</div>
            </div>

            
          
  		)
  	}
}

export default Filters;

